import { FilterFieldType, IFilter } from './types'

export const AUDIT_LOG_LIST_FILTERS_CONFIG = [
  {
    field: 'id',
    type: FilterFieldType.Empty,
    isSortable: true,
    title: 'ID',
    align: 'left',
  },
  {
    field: 'clients',
    dbField: 'client_name',
    type: FilterFieldType.Autocomplete,
    isSortable: true,
    placeholder: 'Client',
    title: 'Client',
  },
  {
    field: 'activities',
    dbField: 'activity',
    type: FilterFieldType.Text,
    isMultiple: true,
    isSortable: true,
    title: 'Activity',
  },
  {
    field: 'users',
    dbField: 'user',
    type: FilterFieldType.Autocomplete,
    isMultiple: true,
    isCustom: true,
    isSortable: true,
    placeholder: 'User',
    title: 'User',
  },
  {
    field: 'tables',
    dbField: '"table"',
    type: FilterFieldType.List,
    isMultiple: true,
    isSortable: true,
    title: 'Table',
  },
  {
    field: 'columns',
    dbField: '"column"',
    type: FilterFieldType.Text,
    isMultiple: true,
    isSortable: true,
    title: 'Column',
  },
  {
    field: 'oldValue',
    dbField: 'old_value',
    type: FilterFieldType.Text,
    isSortable: true,
    placeholder: 'Old Value',
    title: 'Old Value',
  },
  {
    field: 'newValue',
    dbField: 'new_value',
    type: FilterFieldType.Text,
    isSortable: true,
    placeholder: 'New Value',
    title: 'New Value',
  },
  {
    field: 'createdAt',
    dbField: 'created_at',
    alias: 'audit',
    type: FilterFieldType.Datetime,
    isSortable: true,
    title: 'Date',
  },
] as const satisfies IFilter[]
